// components/AppSelect.vue

<script setup>
import { ref, nextTick } from 'vue';
import Select from 'primevue/select';

const select = ref(null);

const emit = defineEmits(['filter']);

const onFilter = async (event) => {
    emit('filter', event); // user ka filter event bhi chale

    await nextTick();

    if (select.value) {
        select.value.focusedOptionIndex = 0;
    }
};
</script>

<template>
    <Select ref="select" v-bind="$attrs" @filter="onFilter">
        <slot />
    </Select>
</template>
